var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.meta.keepAlive)?_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1):_c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }